// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"1baae48c","168":"6198f6ff","200":"0ad38604","375":"0fe48a8d","419":"fcea6b2f","470":"88c5f2da","499":"66e7df74","698":"da42eada","731":"4ef9aca3","747":"9727c9ab","930":"ead4145c"}[chunkId] + ".chunk.js";
};